import React from 'react'

import './index.scss'

export const Footer = () => (
  <footer className="footer">
    ©<a href="https://github.com/abhianuj">Abhijeet</a>, Built with{' '}
    <a>
      Free Tools
    </a>
  </footer>
)
